import { Info } from "lucide-react";
import React from "react";

const PredefinedQuestions = ({
  predefinedQuestions,
  handlePredefinedQuestionClick,
  activeResponsesBotId,
}) => {
  const isElectricCoop = activeResponsesBotId === 2;
  const isInvoicing = activeResponsesBotId === 3;

  return (
    <div className="flex flex-col justify-end w-full h-full max-w-5xl gap-4 px-6 py-8 place-self-center">
      <div className="flex flex-col gap-1">
        <h3 className="text-2xl font-bold text-center dark:text-white">
          How can we help you?
        </h3>
        {isElectricCoop && (
          <h3 className="text-lg font-bold text-center text-yellow-700 dark:text-yellow-300">
            BethAI Electric Coop
          </h3>
        )}
        {isInvoicing && (
          <h3 className="text-lg font-bold text-center text-blue-700 dark:text-blue-300">
            BethAI Invoicing Requirement Checker
          </h3>
        )}
      </div>
      {!isInvoicing && (
        <div className="grid grid-cols-1 gap-4 sm:mt-4 sm:grid-cols-2 lg:grid-cols-3">
          {predefinedQuestions.map((predefined, index) => (
            <button
              key={index}
              className="p-3 text-xs text-gray-900 transition duration-300 rounded shadow bg-slate-200 dark:bg-slate-700 dark:text-gray-100 hover:dark:bg-slate-600 hover:bg-slate-300"
              onClick={() => handlePredefinedQuestionClick(predefined.question)}
              aria-label={`Select question: ${predefined.question}`}>
              {predefined.question}
            </button>
          ))}
        </div>
      )}
      {isInvoicing && (
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center self-center gap-4 p-2 pr-3 rounded-full bg-slate-300 md:translate-y-16 w-fit dark:bg-slate-700 dark:text-gray-200">
            <Info className="size-6" />
            <span className="w-full text-sm font-semibold text-center">
              Please attach an invoice or prompt to start the conversation.
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PredefinedQuestions;
